<template>
    <v-select v-model="model" :items="items" :label="label" :disabled="disabled" :hide-details="!!hideDetails" :required="required" @change="!!onchange ? onchange : () => {}">
        <template slot="selection" slot-scope="{ item, selected }">
            {{ $t(type + '.' + item) }}
        </template>

        <template slot="item" slot-scope="{ item, tile }">
            <v-list-tile-content>
                <v-list-tile-title v-text="$t(type + '.' + item)"></v-list-tile-title>
            </v-list-tile-content>
        </template>
    </v-select>
</template>

<script>
export default {
    name : 'v-select-enum',
    props : ['value', 'items', 'label', 'type', 'disabled', 'hideDetails', 'required', 'onchange'],
    data() {
        return {
            model : ''
        };
    },
    watch : {
        model : {
            handler(val) {
                this.$emit('input', val);
            }
        },
        value : {
            handler(val) {
                this.model = val;
            }
        }
    },
    mounted() {
        this.model = this.value;
    }
}
</script>
